







































import Vue from "vue";
import GoogleMapsApiLoader from "google-maps-api-loader";
import LayerSelector from "./LayerSelector.vue";
import SearchBox from "./SearchBox.vue";
import SearchPlot from "./SearchPlot.vue";
import DistanceCalculator from "./DistanceCalculator.vue";
import {
  mapSettings,
  CIRLE_MARKER_CONFIG,
  // DISTANCE_MARKER_CONFIG,
  POLY_CONFIG,
} from "./config/mapSettings";
import { mapState, mapMutations } from "vuex";
import { SET_SELECTED_PLACE, SET_MAP_LOADED, RootState } from "@/store/types";
import proj4 from "proj4";

export default Vue.extend({
  components: {
    LayerSelector,
    SearchBox,
    DistanceCalculator,
    SearchPlot,
  },

  data() {
    return {
      apiKey: "AIzaSyBPVhvP83qRwYiYx54QYSqgfa2gAdHjU3o",
      google: null,
      map: null,
      geocoder: null,
      marker: null,
      poly: null,
      distanceMarker: null,
      measurementMode: false,
      circle: null,
      kmlLayers: [],
      overlayWms: null,
      polygonLayer: null,
      isWMSLoading: false,
      wmsError: null,
    };
  },

  async mounted() {
    this.google = await GoogleMapsApiLoader({
      libraries: ["places"],
      apiKey: this.apiKey,
    });
    this.initializeMap();
    this.$nextTick(this.setMapLoaded(true));
  },

  computed: {
    ...mapState({
      survey: (state) => (state as RootState).survey,
      layers: (state) => (state as RootState).survey.layers,
      circleRadius: (state) => (state as RootState).mapCircleRadius,
    }),
  },

  watch: {
    circleRadius(): void {
      if (this.circle) {
        this.circle.setRadius(this.circleRadius);
      }
    },
  },

  methods: {
    ...mapMutations({
      setSelectedPlace: SET_SELECTED_PLACE,
      setMapLoaded: SET_MAP_LOADED,
    }),

    handleLayerSelect(payload: { id: number; value: boolean }): void {
      const { id, value } = payload;
      value ? this.addLayerToMap(id) : this.removeLayerFromMap(id);
    },

    initializeMap(): void {
      const mapContainer = this.$refs.googleMap;
      let geoLoc = false
      if(this.survey.geoLoc){
        geoLoc = this.survey.geoLoc.split(",");        
      }            

      this.map = new this.google.maps.Map(mapContainer, {
        ...mapSettings,
        ...(geoLoc) && {
          center: new this.google.maps.LatLng(geoLoc[0], geoLoc[1]),
          zoom: Number(this.survey.zoom)
        },
        zoomControlOptions: {
          position: this.google.maps.ControlPosition.RIGHT_TOP,
        }       
      });
      
      this.geocoder = new this.google.maps.Geocoder();

      if (this.layers && this.layers.length > 0) {
        for (const layer of this.layers) {
          this.kmlLayers.push(
            new this.google.maps.KmlLayer(layer.url, {
              suppressInfoWindows: true,
              preserveViewport: false,
              ...(geoLoc) && {
                preserveViewport: true
              },              
              id: layer.id,
              map: this.map,
            })
          );
        }
      }

      this.map.addListener("click", (e) => this.onMapClick(e.latLng));

      // pobranie granic widocznej mapy
      // idle
      // bounds_changed
      this.map.addListener("idle", () => {        
        const bounds = this.map.getBounds();        
        if (bounds && this.map.getZoom() > 15 && !this.isWMSLoading) {
          this.layerWMS();
        }
        else if (!this.isWMSLoading) {
          this.clearOverlayWms();
        }
      });
    },

    latlngToEPSG2180(coordinates) {
      // WGS84
      const fromProjection = "+proj=longlat +datum=WGS84 +no_defs";

      // EPSG:2180
      // ETRS89 / Poland CS92

      const toProjection =
        "+proj=tmerc +lat_0=0 +lon_0=19 +k=0.9993 +x_0=500000 +y_0=-5300000 +ellps=GRS80 +units=m +no_defs ";

      return proj4(fromProjection, toProjection, [
        coordinates.lng(),
        coordinates.lat(),
      ]);
    },

    EPSG2180Tolatlng(coordinates) {
      const coordinatesArr = coordinates.split(" ");

      // EPSG:2180
      // ETRS89 / Poland CS92

      const fromProjection =
        "+proj=tmerc +lat_0=0 +lon_0=19 +k=0.9993 +x_0=500000 +y_0=-5300000 +ellps=GRS80 +units=m +no_defs ";

      // WGS84
      const toProjection = "+proj=longlat +datum=WGS84 +no_defs";

      return proj4(fromProjection, toProjection, [
        Number(coordinatesArr[0]),
        Number(coordinatesArr[1]),
      ]);
    },
    clearOverlayWms() {
      // czyszczenie overlayWms
      if (this.overlayWms) {
        this.overlayWms.setMap(null);
        this.overlayWms = null;
      }
    },   
    async layerWMS() {
      this.clearOverlayWms();

      this.isWMSLoading = true;
      // tymczasowa blokada możliwości przewijania, zoomowania
      this.map.setOptions({
        draggable: false,
        zoomControl: false,
        scrollwheel: false,
        disableDoubleClickZoom: true,
      });

      const bounds = this.map.getBounds();

      const ne = bounds.getNorthEast();
      const sw = bounds.getSouthWest();

      const neC = this.latlngToEPSG2180(ne);
      const swC = this.latlngToEPSG2180(sw);

      const imageBounds = {
        north: ne.lat(),
        south: sw.lat(),
        east: ne.lng(),
        west: sw.lng(),
      };

      // wymiary viewport
      const mapContainer = this.$refs.googleMap;
      const intViewportWidth = mapContainer.clientWidth;      
      const intViewportHeight = mapContainer.clientHeight;
      const urlWms =      
        "https://integracja.gugik.gov.pl/cgi-bin/KrajowaIntegracjaEwidencjiGruntow?" +
        "&SERVICE=WMS" +
        "&REQUEST=GetMap" +
        "&VERSION=1.3.0" +
        // "&LAYERS=powiaty,powiaty_obreby,zsin,obreby,geoportal,dzialki,numery_dzialek,budynki" +
        "&LAYERS=dzialki,numery_dzialek" +
        "&CRS=EPSG:2180" +
        "&WIDTH=" +
        intViewportWidth +
        "&HEIGHT=" +
        intViewportHeight +
        "&TRANSPARENT=TRUE" +
        "&FORMAT=image/png" +
        "&STYLES=,,,,,,," +
        "&EXCEPTIONS=xml" +
        "&BBOX=" +
        swC[1] +
        "," +
        swC[0] +
        "," +
        neC[1] +
        "," +
        neC[0];

      const param = {
        method: "HEAD",
        // mode: 'cors',
      };

      await fetch(urlWms, param)
        .then((response) => {
          if (response.status == 200) {
            this.overlayWms = new this.google.maps.GroundOverlay(
              urlWms,
              imageBounds
            );
            // umozliwienie dla warstwy GroundOverlay kliknięcia (mierzenie dsytansu, itd)
            this.overlayWms.addListener("click", (e) =>
              this.onMapClick(e.latLng)
            );
            this.overlayWms.setMap(this.map);
            this.isWMSLoading = false;
            this.wmsError = null;
            // przywrócenie po wczytaniu GroundOverlay możliwości przewijania, zoomowania
            this.map.setOptions({
              draggable: true,
              zoomControl: true,
              scrollwheel: true,
            });
          } else {
            this.isWMSLoading = false;
            this.wmsError = response.status;
            this.map.setOptions({
              draggable: true,
              zoomControl: true,
              scrollwheel: true,
            });
          }
          this.urlWms = response.url;
        })
        .catch((err) => {
          this.isWMSLoading = false;
          this.wmsError = err;
          this.map.setOptions({
            draggable: true,
            zoomControl: true,
            scrollwheel: true,
          });
        });
    },

    drawPlot(polygonString) {
      // czyszczenie
      if (this.polygonLayer) this.polygonLayer.setMap(null);

      // wyciąganie ze stringa poligonu
      let polygonSubString = polygonString.substring(
        polygonString.indexOf("((") + 2,
        polygonString.lastIndexOf("))")
      );
      
      // usunięcie nawiasów dla niektórych działek 
      polygonSubString = polygonSubString.replace('(', '').replace(')', '')

      const polygonCoord = polygonSubString.split(",");     
      const plotCoords = [];
      const bounds = new this.google.maps.LatLngBounds();

      for (const a of polygonCoord) {
        const cordArr = this.EPSG2180Tolatlng(a);
        plotCoords.push({ lat: cordArr[1], lng: cordArr[0] });
        const point = new this.google.maps.LatLng(cordArr[1], cordArr[0]);
        bounds.extend(point);
      }

      // rysowanie działki
      this.polygonLayer = new this.google.maps.Polygon({
        paths: plotCoords,
        strokeColor: "#0000ff",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#0000ff",
        fillOpacity: 0.35,
      });

      this.polygonLayer.setMap(this.map);

      // przesunięcie i przeskalowanie mapy na szukaną działkę
      this.map.setCenter(bounds.getCenter());
      this.map.fitBounds(bounds,300);
    },

    addLayerToMap(id: number) {
      const layer = this.getLayer(id);

      if (layer) {
        layer.preserveViewport = true;
        layer.setMap(this.map);
      }
    },

    removeLayerFromMap(id: number) {
      const layer = this.getLayer(id);
      if (layer) layer.setMap(null);
    },

    getLayer(id: number): Record<string, any> | null {
      return this.kmlLayers.find((layer) => layer.id === id) || null;
    },

    setMeasurementMode(val: boolean): void {
      if (!val) {
        if (this.poly) this.poly.setMap(null);
        if (this.distanceMarker) this.distanceMarker.setMap(null);
        this.poly = null;
        this.distanceMarker = null;
      }
      this.measurementMode = val;
    },

    onMapClick(latLng): void {
      const searchBox = document.querySelector(".search-box") as HTMLElement;
      if (searchBox) searchBox.blur();

      if (!this.measurementMode) {
        this.geocodeLatLng(latLng);
        return;
      }

      if (this.distanceMarker) {
        this.distanceMarker.setPosition(latLng);
      } else {
        this.addDistanceMarker(latLng);
        this.google.maps.event.addListener(this.distanceMarker, "drag", () => {
          this.poly.setPath([
            this.marker.position,
            this.distanceMarker.position,
          ]);
        });
      }

      if (this.poly) {
        this.poly.setPath([this.marker.position, this.distanceMarker.position]);
      } else {
        this.addPoly([this.marker.position, this.distanceMarker.position]);
      }
    },

    addMarker(latLng): void {
      const { Marker } = this.google.maps;

      this.marker = new Marker({
        position: latLng,
        marker: this.marker,
        map: this.map,
        draggable: true,
      });

      this.google.maps.event.addListener(this.marker, "drag", () => {
        this.circle.setCenter(this.marker.position);
        if (this.poly)
          this.poly.setPath([
            this.marker.position,
            this.distanceMarker.position,
          ]);
      });

      this.google.maps.event.addListener(this.marker, "dragend", (e) => {
        this.geocodeLatLng(e.latLng);
      });
    },

    addDistanceMarker(latLng): void {
      const { Marker } = this.google.maps;

      this.distanceMarker = new Marker({
        position: latLng,
        marker: this.distanceMarker,
        map: this.map,
        draggable: true,
        // icon: DISTANCE_MARKER_CONFIG,
      });
    },

    addPoly(path) {
      const { Polyline } = this.google.maps;

      this.poly = new Polyline({
        ...POLY_CONFIG,
        map: this.map,
        path,
      });
    },

    addCircle(latLng): void {
      const { Circle } = this.google.maps;

      this.circle = new Circle({
        center: latLng,
        radius: this.circleRadius,
        map: this.map,
        ...CIRLE_MARKER_CONFIG,
      });

      this.google.maps.event.addListener(this.circle, "click", (e) => {
        if (!this.measurementMode) this.geocodeLatLng(e.latLng);
      });
    },

    geocodeLatLng(LatLng) {
      this.geocoder.geocode({ location: LatLng }, (results, status) => {
        if (status === "OK") {
          if (results[0]) {
            this.marker
              ? this.marker.setPosition(LatLng)
              : this.addMarker(LatLng);

            this.circle
              ? this.circle.setCenter(LatLng)
              : this.addCircle(LatLng);

            this.setSelectedPlace(this.formatPlaceData(results[0]));
          } else {
            window.alert("No results found");
          }
        } else {
          window.alert("Geocoder failed due to: " + status);
        }
      });
    },

    formatPlaceData(data) {
      const addr = data["address_components"];
      const formattedData = {
        location: {
          lat: this.marker.position.lat(),
          lng: this.marker.position.lng(),
        },
        address: {
          streetName: this.getAddressType(addr, "route"),
          streetNumber: this.getAddressType(addr, "street_number"),
          postalCode: this.getAddressType(addr, "postal_code"),
          county: this.getAddressType(addr, "administrative_area_level_2"),
          town: this.getAddressType(addr, "locality"),
          municipality: "",
        },
      };

      return formattedData;
    },

    getAddressType(address: Array<Record<string, any>>, type: string): string {
      const value = address.find((i) => i.types.includes(type));
      if (value) {
        if (
          (type === "postal_code" && value.long_name.length < 6) ||
          (type === "route" && value.long_name === "Unnamed Road")
        ) {
          return "";
        }
        return value.long_name;
      }

      return "";
    },
  },
});
